import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Las Primeras Palabras',
    desc: 'Guía para estimular el lenguaje en los primeros años.',
    img: 'https://cdn.magicpatterns.com/uploads/3K2TfRQVDFNBF9RzEQ2Xn2/ChatGPT_Image_21_may_2026,_23_56_52.png'
  }, {
    num: 2,
    title: 'Números y Grafomotricidad',
    desc: '+48 páginas de conteo, trazos y coordinación.',
    img: 'https://cdn.magicpatterns.com/uploads/uCVyqwARyspzeGqRzuySA7/ChatGPT_Image_21_may_2026,_23_58_16.png'
  }, {
    num: 3,
    title: 'Observación y Coordinación',
    desc: 'Juegos visuales para desarrollar atención y lógica.',
    img: 'https://cdn.magicpatterns.com/uploads/aDcfg38Fj8bBiVpro1FmJp/ChatGPT_Image_21_may_2026,_23_59_35.png'
  }, {
    num: 4,
    title: 'Guía Práctica para Padres',
    desc: 'Cómo acompañar el desarrollo en cada etapa.',
    img: 'https://cdn.magicpatterns.com/uploads/pMPtBLi29cyick4MKq1Pdy/ChatGPT_Image_22_may_2026,_00_01_59.png'
  }, {
    num: 5,
    title: 'Planificador Imprimible',
    desc: 'Organizá tu rutina familiar sin estrés.',
    img: 'https://cdn.magicpatterns.com/uploads/57oTt8ZY7BSKT11jKdUows/ChatGPT_Image_22_may_2026,_00_03_19.png'
  }];
  return <section className="bg-gradient-to-b from-white to-brand-green-50/40 px-5 py-10 sm:py-12" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="text-center mb-8" data-id="element-31">
          <div className="inline-flex items-center gap-2 bg-brand-cream-100 text-brand-ink rounded-full px-4 py-1.5 mb-4" data-id="element-32">
            <GiftIcon className="w-4 h-4" data-id="element-33" />
            <span className="text-xs font-bold uppercase tracking-wide" data-id="element-34">
              5 Bonos incluidos
            </span>
          </div>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-35">
            También te llevás{' '}
            <span className="highlight-yellow" data-id="element-36">5 regalos extras</span>
          </h2>
          <p className="mt-3 text-slate-600" data-id="element-37">
            <span className="line-through text-slate-400" data-id="element-38">Valor $67.000</span>{' '}
            <span className="font-bold text-brand-green-600" data-id="element-39">Gratis hoy</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-40">
          {bonuses.map(bonus => <a key={bonus.num} href="https://impulsodigital.vip/cart/44763616936022:1" className="group bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-soft hover:shadow-soft-lg transition-all duration-200 flex flex-row sm:flex-col" data-id="element-41">
              <div className="relative w-28 sm:w-full shrink-0 bg-brand-green-50/40 overflow-hidden" data-id="element-42">
                <span className="absolute top-2 left-2 z-10 text-[10px] font-bold uppercase tracking-wider bg-white text-brand-green-700 px-2 py-0.5 rounded-full shadow-soft" data-id="element-43">
                  Bono {bonus.num}
                </span>
                <img src={bonus.img} alt={bonus.title} className="w-full h-full sm:aspect-[4/3] object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-44" />
              </div>
              <div className="p-4 sm:p-5 flex-1 flex flex-col justify-center" data-id="element-45">
                <h3 className="font-bold text-brand-ink leading-tight" data-id="element-46">
                  {bonus.title}
                </h3>
                <p className="text-sm text-slate-500 mt-1 leading-snug" data-id="element-47">
                  {bonus.desc}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-10" data-id="element-48">
          <CTAButton text="Quiero el kit + los 5 bonos" data-id="element-49" />
        </div>
      </div>
    </section>;
}